import { Navigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, loading, userProfile } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth/login" replace />;
  }

  // Allow access if EITHER email OR phone is verified
  const emailVerified = !!user.email_confirmed_at;
  const phoneVerified = userProfile?.phone_verified === true;

  if (!emailVerified && !phoneVerified) {
    return <Navigate to="/auth/verify-required" replace />;
  }

  return <>{children}</>;
};
